"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockRouter = exports.createLink = exports.createClickHandler = exports.wantsNewTab = exports.routeToString = exports.replaceRoute = exports.pushRoute = exports.replaceParams = exports.removeParams = exports.findParams = void 0;
var events_1 = require("events");
var url_1 = __importDefault(require("url"));
var noop = function () { return undefined; };
function omit(obj, properties) {
    var keys = Object.keys(obj);
    var res = {};
    for (var i = 0; i < keys.length; i += 1) {
        var key = keys[i];
        var val = obj[key];
        if (properties.indexOf(key) === -1) {
            res[key] = val;
        }
    }
    return res;
}
/**
 * Get all of the matches within a string
 * @param regex Any regex object
 * @param str A string to find the matches in
 * @param matches Internal argument to build the matches
 */
function findMatches(regex, str, matches) {
    if (matches === void 0) { matches = []; }
    var res = regex.exec(str);
    var match = res && res[1];
    if (match) {
        matches.push(match);
        findMatches(regex, str, matches);
    }
    return matches;
}
/**
 * Find all matching params within a string
 * @param pathname The url with [:id] type params
 */
function findParams(pathname) {
    return findMatches(/\[([a-zA-Z0-9]+)\]/g, pathname);
}
exports.findParams = findParams;
/**
 * Returns a new query object without the values of the params
 * @param pathname The url with params
 * @param query Object of params
 */
function removeParams(pathname, query) {
    return omit(query !== null && query !== void 0 ? query : {}, findParams(pathname));
}
exports.removeParams = removeParams;
/**
 * Replace all params within a url with values from an object
 * @param str
 * @param params
 */
function replaceParams(str, params) {
    if (!params)
        return str;
    var pathname = str;
    Object.keys(params).forEach(function (key) {
        var value = params[key];
        var stringValue = Array.isArray(value) ? value.join(',') : value;
        pathname = pathname.replace("[" + key + "]", stringValue !== null && stringValue !== void 0 ? stringValue : '');
    });
    return pathname;
}
exports.replaceParams = replaceParams;
/**
 * Calls router.push with a route object. This will automatically generate the href and as params.
 *
 *    const router = useRouter();
 *    pushRoute(router, {
 *      pathname: '/admin/producer-dasboard/[uuid]',
 *      query: {
 *        uuid: '1',
 *        tab: 'requests'
 *      }
 *    })
 *
 * @param router The Next router from useRouter
 * @param route The route information
 */
function pushRoute(router, route, options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, navigate(router, route, 'push', options)];
        });
    });
}
exports.pushRoute = pushRoute;
/**
 * Calls router.replace with a route object. This will automatically generate the href and as params.
 *
 *    const router = useRouter();
 *    pushRoute(router, {
 *      pathname: '/admin/producer-dasboard/[uuid]',
 *      query: {
 *        uuid: '1',
 *        tab: 'requests'
 *      }
 *    })
 *
 * @param router The Next router from useRouter
 * @param route The route information
 */
function replaceRoute(router, route, options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, navigate(router, route, 'replace', options)];
        });
    });
}
exports.replaceRoute = replaceRoute;
/**
 * Calls router.push or router.replace
 */
function navigate(router, route, type, options) {
    return __awaiter(this, void 0, void 0, function () {
        var pathname, query, queryWithoutParams, shouldScroll, success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pathname = route.pathname, query = route.query;
                    queryWithoutParams = omit(query || {}, findParams(pathname));
                    shouldScroll = pathname.indexOf('#') > -1;
                    return [4 /*yield*/, router[type]({
                            pathname: pathname,
                            query: query,
                        }, {
                            pathname: replaceParams(pathname, query),
                            query: queryWithoutParams,
                        }, options)];
                case 1:
                    success = _a.sent();
                    if (success && shouldScroll) {
                        window.scrollTo(0, 0);
                        document.body.focus();
                    }
                    return [2 /*return*/, success];
            }
        });
    });
}
/**
 * Take a route with a pathname and optional query and turn it into a real path.
 * This will also replace any params, like [:id], within the string
 * @param route The route to transform into a string
 */
function routeToString(router, route) {
    var pathname = route.pathname, _a = route.query, query = _a === void 0 ? {} : _a;
    var _b = router.basePath, basePath = _b === void 0 ? '' : _b;
    return url_1.default.format({
        pathname: "" + basePath + replaceParams(pathname, query),
        query: removeParams(pathname, query),
    });
}
exports.routeToString = routeToString;
/**
 * When a user clicks a link determine if they're trying to open in a new tab.
 */
function wantsNewTab(e) {
    var nodeName = e.currentTarget.nodeName;
    var target = e.currentTarget.getAttribute('target');
    // HTML target attribute
    if (target && target !== '_self') {
        return true;
    }
    // ignore click for new tab / new window behavior
    // https://github.com/zeit/next.js/blob/canary/packages/next/client/link.tsx#L140
    if (nodeName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || (e.nativeEvent && e.nativeEvent.which === 2))) {
        return true;
    }
    return false;
}
exports.wantsNewTab = wantsNewTab;
function createClickHandler(router, route, options) {
    return function (e) {
        if (wantsNewTab(e))
            return;
        e.preventDefault();
        pushRoute(router, route, options);
    };
}
exports.createClickHandler = createClickHandler;
/**
 * Create a link to a route that can be used with HTML anchor tags
 * @param router The next router instance
 * @param route
 */
function createLink(router, route, options) {
    return {
        route: route,
        isActive: router.route === route.pathname,
        push: function () { return pushRoute(router, route, options); },
        replace: function () { return replaceRoute(router, route, options); },
        onClick: createClickHandler(router, route),
        href: routeToString(router, route),
    };
}
exports.createLink = createLink;
/**
 * This function creates a mock NextRouter object that can be used in tests and stories. Just call createMockRouter
 * with a pathname and an optional query object. This will return a plain object with the same
 * shape as NextRouter.
 *
 * You can spy on this router in tests by using `jest.spyOn(router, 'push')`. This will let you assert that the router
 * was correctly called using `expect(router.push).toHaveBeenCalledWith(...)`.
 *
 *    const router = createMockRouter({
 *      pathname: '/admin/producer-dashboard/requests/[uuid]',
 *      query: {
 *        uuid: 'sdfsdf'
 *      }
 *    })
 *
 * You can use this as a replacement for the router in <RouterProvider> to set the router on React's context.
 * @param options
 */
function createMockRouter(options) {
    var pathname = options.pathname, _a = options.query, query = _a === void 0 ? {} : _a, _b = options.basePath, basePath = _b === void 0 ? '' : _b;
    return {
        pathname: pathname,
        isLocaleDomain: true,
        isReady: true,
        isPreview: false,
        isFallback: false,
        query: query,
        basePath: basePath,
        asPath: routeToString({ basePath: '' }, {
            pathname: pathname,
            query: query,
        }),
        route: pathname,
        back: noop,
        beforePopState: noop,
        push: function () { return Promise.resolve(true); },
        replace: function () { return Promise.resolve(true); },
        reload: noop,
        prefetch: function () { return Promise.resolve(); },
        events: new events_1.EventEmitter(),
    };
}
exports.createMockRouter = createMockRouter;
